<template>
  <div class="airportList">
    <AirportItem class="airportItem"
      v-for="item in list"
      :key="item.airportName"
      :item="item"
      :locale="locale"
      :lang="lang" />
  </div>
</template>

<script>
import AirportItem from '@/components/FlightInfo/AirportItem.vue'
export default {
  name: 'Airport',
  props: [
    'locale',
    'lang',
    'list'
  ],
  components: {
    AirportItem
  }
}
</script>

<style lang="scss" scoped>
.airportList {
  display: flex;
  align-items: flex-start;
  flex-flow: wrap;
  padding: 30px 15px;
}
.airportItem  {
  flex-basis: 100%;
  margin-bottom: 30px;
  overflow: hidden;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
}
@media screen and (min-width: 900px) {
  .airportList {
    flex-flow: nowrap;
    padding: 15px 8px 30px;
  }
  .airportItem {
    flex-basis: 50%;
    margin: 0 8px;
  }
}
@media screen and (min-width: 1600px) {
  .airportItem {
    flex-basis: 33.33%;
  }
}
</style>
